export const getSingleProduct = (id: string) => ({
  type: "@saga/GET_SINGLE_PRODUCT",
  payload: id,
});
